class SuperMegaMenuController {
  constructor(root) {
    this.root = root;
    this.details = root.matches('details') ? root : root.querySelector('details');
    this.onClick = this.onClick.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onL3MouseEnter = this.onL3MouseEnter.bind(this);
    this.onL2PanelMouseEnter = this.onL2PanelMouseEnter.bind(this);

    this.root.addEventListener('click', this.onClick);
    this.details?.addEventListener('toggle', this.onToggle);
    this.bindLevel3Hover();
    this.bindHeaderMenuHover();
  }

  bindHeaderMenuHover() {
    const headerMenu = this.root.closest('header-menu');
    if (!headerMenu || headerMenu._superMegaHoverBound) return;
    headerMenu._superMegaHoverBound = true;

    headerMenu.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        this.onMenuHoverOpen();
      }
    });
  }

  bindLevel3Hover() {
    this.root.querySelectorAll('.super-mega-menu__l3-item').forEach((item) => {
      if (item.dataset.saL3HoverBound === 'true') return;
      item.dataset.saL3HoverBound = 'true';
      item.addEventListener('mouseenter', this.onL3MouseEnter);
    });

    this.root.querySelectorAll('.super-mega-menu__l2-trigger--panel').forEach((item) => {
      if (item.dataset.saL2HoverBound === 'true') return;
      item.dataset.saL2HoverBound = 'true';
      item.addEventListener('mouseenter', this.onL2PanelMouseEnter);
    });
  }

  onToggle() {
    if (!this.details?.open) return;
    this.expandDefaultLevel2();
    this.activateFirstPanel();
  }

  onMenuHoverOpen() {
    this.expandDefaultLevel2();
    this.activateFirstPanel();
  }

  onL3MouseEnter(event) {
    const l3Item = event.currentTarget;
    if (!l3Item?.dataset.panelId) return;
    this.activatePanel(l3Item.dataset.panelId, l3Item);
  }

  onL2PanelMouseEnter(event) {
    const trigger = event.currentTarget;
    if (!trigger?.dataset.panelId) return;
    this.activatePanel(trigger.dataset.panelId, trigger);
  }

  onClick(event) {
    const l2Trigger = event.target.closest('.super-mega-menu__l2-trigger:not(.super-mega-menu__l2-trigger--panel)');
    if (l2Trigger) {
      event.preventDefault();
      this.toggleLevel2(l2Trigger);
    }
  }

  expandDefaultLevel2() {
    const expanded = this.root.querySelector('.super-mega-menu__l2-item.is-expanded');
    if (expanded) return;

    const firstL2 = this.root.querySelector('.super-mega-menu__l2-item .super-mega-menu__l2-trigger:not(.super-mega-menu__l2-trigger--panel)');
    if (!firstL2) return;

    const item = firstL2.closest('.super-mega-menu__l2-item');
    if (!item) return;

    item.classList.add('is-expanded');
    firstL2.classList.add('is-active');
    firstL2.setAttribute('aria-expanded', 'true');
  }

  toggleLevel2(trigger) {
    const item = trigger.closest('.super-mega-menu__l2-item');
    if (!item) return;

    const isExpanded = item.classList.contains('is-expanded');

    this.root.querySelectorAll('.super-mega-menu__l2-item').forEach((l2Item) => {
      l2Item.classList.remove('is-expanded');
      const l2Trigger = l2Item.querySelector('.super-mega-menu__l2-trigger:not(.super-mega-menu__l2-trigger--panel)');
      if (l2Trigger) {
        l2Trigger.classList.remove('is-active');
        l2Trigger.setAttribute('aria-expanded', 'false');
      }
    });

    if (!isExpanded) {
      item.classList.add('is-expanded');
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');

      const firstL3 = item.querySelector('.super-mega-menu__l3-item');
      if (firstL3) {
        this.activatePanel(firstL3.dataset.panelId, firstL3);
      }
    }
  }

  activatePanel(panelId, activeItem) {
    if (!panelId) return;

    this.root.querySelectorAll('.super-mega-menu__l3-item, .super-mega-menu__l2-trigger--panel').forEach((item) => {
      item.classList.remove('is-active');
      item.setAttribute('aria-current', 'false');
    });

    this.root.querySelectorAll('.super-mega-menu__panel').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    const panel = this.root.querySelector(`.super-mega-menu__panel[data-panel-id="${panelId}"]`);
    if (panel) {
      panel.classList.add('is-active');
      panel.hidden = false;
    }

    if (activeItem) {
      activeItem.classList.add('is-active');
      activeItem.setAttribute('aria-current', 'true');
    }
  }

  activateFirstPanel() {
    const firstL3 =
      this.root.querySelector('.super-mega-menu__l2-item.is-expanded .super-mega-menu__l3-item.is-active') ||
      this.root.querySelector('.super-mega-menu__l2-item.is-expanded .super-mega-menu__l3-item') ||
      this.root.querySelector('.super-mega-menu__l3-item.is-active') ||
      this.root.querySelector('.super-mega-menu__l3-item') ||
      this.root.querySelector('.super-mega-menu__l2-trigger--panel.is-active') ||
      this.root.querySelector('.super-mega-menu__l2-trigger--panel');

    if (firstL3) {
      this.activatePanel(firstL3.dataset.panelId, firstL3);
    }
  }
}

function initSuperMegaMenus() {
  document.querySelectorAll('[data-super-mega-menu]').forEach((root) => {
    if (root.superMegaMenuController) return;
    root.superMegaMenuController = new SuperMegaMenuController(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSuperMegaMenus);
} else {
  initSuperMegaMenus();
}

document.addEventListener('shopify:section:load', initSuperMegaMenus);
